import React, {Component} from 'react'
import AdminService from "../AdminService";

export default class ZarzadzanieStronami extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            kategorie: [],
            strony: [],
            loading: true
        }

    }

    componentWillMount() {
        AdminService.getKategorie()
            .then(function (response) {
                this.setState({kategorie: response.data.content});
                AdminService.getStrony()
                    .then(function (response) {
                        this.setState({loading: false, strony: response.data.content})
                    }.bind(this)).catch(err => {
                    console.log(err)
                })
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    renderAkcjeKategoria(item) {
        return <div>
            <i className="fa fa-trash" aria-hidden="true" style={{paddingLeft: 10}}
               onClick={() => this.deleteItem(item)}> </i>
        </div>
    }

    renderAkcjeStrona(item) {
        return <div>
            <i className="fa fa-trash" aria-hidden="true" style={{paddingLeft: 10}}
               onClick={() => this.deleteStrona(item)}> </i>
        </div>
    }

    checkRedirect(item) {
        if (item.tresc.substr(0, 4) === 'http') {
            return <i className="fa fa-link" aria-hidden="true"></i>
        } else {
            return null;
        }
    }

    deleteItem(item) {
        let pusta = true;
        for (let i = 0; i < this.state.strony.length; i++) {
            if (this.state.strony[i].kategoria !== null) {
                if (this.state.strony[i].kategoria.id === item.id) {
                    pusta = false
                }
            }
        }
        if (!pusta) {
            alert("Nie można usunąć kategorii posiadającej strony!")
        } else {
            if (window.confirm("Czy na pewno chcesz usunąć wybraną kategorię?")) {
                AdminService.deleteKategoria(item.id)
                    .then(function (response) {
                        this.componentWillMount()
                    }.bind(this)).catch(err => {
                    console.log(err)
                })
            } else {
                return null;
            }
        }
    }

    deleteStrona(item) {
        if (window.confirm("Czy na pewno chcesz usunąć stronę?")) {
            AdminService.deleteStrona(item.id)
                .then(function (response) {
                    this.componentWillMount()
                }.bind(this)).catch(err => {
                console.log(err)
            })
        } else {
            return null;
        }
    }

    render() {
        return <div className="aktualnosciTabContainer">
            <div className="aktualnosciOpis">
                Ta zakładka umożliwia zarządzanie stronami. Aby usunąć lub edytować istniejące strony lub kategorie
                należy wybrać przycisk po prawej stronie danego wpisu.
            </div>
            <div className="aktualnosciWpisy">
                <div className="row" style={{fontWeight: 'bold', padding: '10px', marginTop: 25}}>
                    <div className="col-sm-2">Kategorie i strony stopki witryny:</div>
                </div>
                {this.state.loading ? <div>
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> : <div>
                    {this.state.kategorie.length > 0 ? <div>
                        {this.state.kategorie.map((item, index) => {
                            return <div style={{marginBottom: 10}}>
                                <div className="row kategoria">
                                    <div className="col-sm-11">{item.nazwa}</div>
                                    {item.nazwa === 'Elementy witryny' ? null :
                                        <div className="col-sm-1 text-right">{this.renderAkcjeKategoria(item)}</div>}
                                </div>
                                {this.state.strony.map((i, index) => {
                                    if (i.kategoria !== null) {
                                        if (i.kategoria.id === item.id) {
                                            return <div className="row strona">
                                                <div className="col-sm-11" onClick={() => {
                                                    this.props.setId(i.id);
                                                    this.props.setItem(i);
                                                    this.props.goEdycja()
                                                }}>
                                                    {i.tytul} {this.checkRedirect(i)}
                                                </div>
                                                {item.nazwa === 'Elementy witryny' ? null : <div
                                                    className="col-sm-1 text-right">{this.renderAkcjeStrona(i)}</div>}
                                            </div>
                                        }
                                    }
                                })
                                }</div>
                        })}
                    </div> : <div className="text-center" style={{paddingTop: 15}}>Brak stron</div>}</div>}
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/stronyComponents/ZarzadzanieStronami.js